import { ToEntity } from 'core/common/mappers';
import { NatalChartBlockValue } from '../entities';
import { BlockValueDto } from '../services/content/dto';

export class NatalChartContentMapper implements ToEntity<NatalChartBlockValue, BlockValueDto> {
  toEntity(dto: BlockValueDto): NatalChartBlockValue {
    return {
      blockName: dto.block_name,
      id: dto.id,
      summary: dto.content.summary || dto.content.paragraphs?.[0]?.text || '',
    };
  }
}
